<template>
  <div class="dea-modal-create-student" :class="{ 'dea-modal-create-student--visible': visible }">
    <HeaderFlow
      class="header--flow--student"
      :logos="$root.config.logos"
      :sections="{}"
      @closed="$emit('modal-close')"
    ></HeaderFlow>
    <div class="dea-modal-create-student__form-container">
      <div class="dea-heading--medium__ml dea-modal-create-student__title">Aggiungi uno/a studente/ssa:</div>
      <InputText
        v-model="student.firstname"
        label="Nome"
        :message="errors.firstname.message"
        :state="errors.firstname.state"
      ></InputText>
      <InputText
        v-model="student.lastname"
        label="Cognome"
        :message="errors.lastname.message"
        :state="errors.lastname.state"
      ></InputText>
      <div class="dea-modal-create-student__input-block dea-modal-create-student__date">
        <div class="dea-heading--medium-m dea-modal-create-student__section-title">Data di nascita</div>
        <DateSelect
          :need-check="checkDate"
          :user="student"
          @check-needed="checkDate = false"
          @user-update="dateUpdate($event)"
        />
      </div>
      <div class="dea-modal-create-student__input-block">
        <div class="dea-heading--medium-m dea-modal-create-student__section-title">E-mail</div>
        <div class="dea-heading--medium-s dea-modal-create-student__section-subtitle">
          Lo studente o studentessa ha un suo indirizzo e-mail?
        </div>
        <Checkbox id="check-yes" class="dea-checkbox--regular" type="radio" name="yesNo" @change="hasEmail = true">
          Si
        </Checkbox>
        <Checkbox id="check-no" class="dea-checkbox--regular" type="radio" name="yesNo" @change="hasEmail = false">
          No
        </Checkbox>
        <div v-if="hasEmail" class="dea-modal-create-student__email-add">
          <InputText
            v-model="student.email"
            label="Allora associalo al profilo!"
            :message="errors.email.message"
            placeholder="Scrivi e-mail studente"
            :state="errors.email.state"
            type="email"
          />
          <div class="dea-heading--light-s dea-modal-create-student__email-description">
            Lo studente o studentessa potrà usare e-mail e password per accedere a Deascuola senza il tuo aiuto (anche
            se continuerai ad assere tu responsabile della gestione del profilo Famiglia). L'indirizzo indicato sarà
            utilizzato nel collegamento ad altre piattaforme.
          </div>
        </div>
        <div
          v-else-if="hasEmail !== null && !hasEmail"
          class="dea-modal-create-student__input-block dea-modal-create-student__input-block--no-margin"
        >
          <div class="dea-heading--medium-s">Non preoccuparti ne creiamo uno noi:</div>
          <div class="dea-modal-create-student__email-custom">
            <div class="dea-heading--medium-s">!!Email custom TBD!!</div>
            <Links
              class="dea-links--large  dea-links--align-left"
              :class-name="`dea-links--${user.targetCss.colorMod}`"
              icon="scroll-down"
              >Scarica memo</Links
            >
          </div>
          <div class="dea-heading--light-s dea-modal-create-student__email-description">
            Questo indirizzo e-mail, associato alla password, potrà essere usato dallo studente o studentessa per
            accedere a Deascuola senza il tuo aiuto (anche se continuerai ad essere tu responsabile della gestione del
            profilo famiglia). Sarà inoltre utilizzato nel collegamento ad altre piattaforme.
          </div>
        </div>
      </div>
      <div class="dea-modal-create-student__input-block">
        <InputText
          v-model="student.password"
          label="Password"
          :message="errors.password.message"
          :state="errors.password.state"
          :type="passwordInputType.old"
        />
        <Links
          class="dea-links--large dea-links--pointer"
          :class-name="`dea-links--${user.targetCss.colorMod}`"
          @click="switchPwdType('old')"
        >
          {{ switchPWdLabel.old }}
        </Links>
      </div>
      <div class="dea-modal-create-student__input-block">
        <div class="dea-heading--medium-m dea-modal-create-student__section-title">
          Scegli un'immagine di profilo per lo/a studente/ssa:
        </div>
        <ChangeAvatar
          :link-color="user.targetCss.colorMod"
          :src="`${$root.config.avatarsURL}/student/${student.avatar}.svg`"
          @click="toggleAvatarModal(true)"
        />
      </div>
      <div class="dea-modal-create-student__input-block dea-modal-create-student__school-grade">
        <div class="dea-heading--medium-m dea-modal-create-student__section-title">Seleziona un grado scolastico</div>
        <div class="dea-modal-create-student__main-grade-choice">
          <Buttons
            v-for="(grade, index) in $root.config.grades"
            :key="index"
            class="dea-button--large dea-button--outline"
            :class="[
              { 'dea-button--disabled': studentSchoolDisabled(grade) },
              { 'dea-button--selected': studentSchoolSelected(grade) },
            ]"
            @click="updateUserSchoolInfo({ label: 'student_school', value: grade })"
          >
            {{ grade }}
          </Buttons>
        </div>
      </div>
      <div
        v-if="studentSchoolSelected(lastGrade)"
        class="dea-modal-create-student__input-block dea-modal-create-student__input-block--inline"
      >
        <div class="dea-heading--medium-m dea-modal-create-student__section-title">Seleziona una tipologia</div>
        <div class="dea-modal-create-student__typology-choice">
          <Buttons
            v-for="(typology, index) in $root.config.schoolsTypologies"
            :key="index"
            class="dea-button--large dea-button--outline"
            :class="[
              { 'dea-button--disabled': student.student_school && student.student_school !== typology },
              { 'dea-button--selected': student.student_school === typology },
            ]"
            @click="updateUserSchoolInfo({ label: 'student_school', value: typology })"
          >
            {{ typology }}
          </Buttons>
        </div>
      </div>
      <div
        v-if="errors.school.state === 'error'"
        class="dea-modal-create-student__grade-error dea-input__support-message dea-input__error-message"
      >
        {{ errors.school.message }}
      </div>
      <Buttons class="dea-button--large dea-modal__submit-button" @click="saveStudent()">Salva modifiche</Buttons>
      <AvatarModal
        v-if="showAvatarsModal"
        :user="{ role: 'ROLE_STUDENT' }"
        :visible="showAvatarsModal"
        @modal-close="toggleAvatarModal(false)"
        @user-update="updateUserAvatar"
      />
    </div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions } from "vuex";
import Buttons from "@/components/elements/Buttons";
import ChangeAvatar from "@/components/patterns/ChangeAvatar";
import Checkbox from "@/components/elements/Checkbox";
import HeaderFlow from "@/components/patterns/HeaderFlow";
import InputText from "@/components/elements/InputText";
import Links from "@/components/elements/Links";
import AvatarModal from "~/components/myProfile/modals/AvatarModal";
import User from "~/clients/user";
import showPassword from "~/components/myProfile/mixins/showPassword";
import DateSelect from "~/components/myProfile/components/DateSelect";

export default {
  name: "StudentModal",
  components: { AvatarModal, Buttons, ChangeAvatar, Checkbox, DateSelect, HeaderFlow, InputText, Links },
  mixins: [showPassword],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkDate: false,
      lastGrade: "Secondaria di II grado",
      errors: {
        email: {
          state: "",
          message: "",
        },
        date: {
          state: "",
          message: "",
        },
        firstname: {
          state: "",
          message: "",
        },
        lastname: {
          state: "",
          message: "",
        },
        password: {
          state: "",
          message: "",
        },
        school: {
          state: "",
          message: "",
        },
      },
      hasEmail: null,
      showAvatarsModal: false,
      student: {
        avatar: "1",
        firstname: "",
        birth_day: null,
        birth_month: null,
        birth_year: null,
        cons_promo: false,
        cons_promo3: false,
        cons_consumi: false,
        email: null,
        lastname: "",
        password: null,
        role: "ROLE_STUDENT",
        sito_sorgente: this.$root.config.sourceSite,
        student_school: null,
      },
    };
  },
  computed: {
    studentModal() {
      return document.querySelector(".dea-modal-create-student");
    },
    emailCorrect() {
      if (this.student.email && this.student.email.includes("@") && this.student.email.includes(".")) return true;
      return false;
    },
    passwordValid() {
      if (this.student.password && this.student.password.length >= 6) return true;
      return false;
    },
    schoolValid() {
      if (this.student.student_school && this.student.student_school !== this.lastGrade) return true;
      return false;
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
    checkValidity() {
      if (!this.student.firstname) {
        this.toggleError("firstname", "error", "Inserisci il nome");
      } else {
        this.toggleError("firstname", "", "");
      }
      if (!this.student.lastname) {
        this.toggleError("lastname", "error", "Inserisci il cognome");
      } else {
        this.toggleError("lastname", "", "");
      }
      if (!this.emailCorrect) {
        this.toggleError("email", "error", "Email errata");
      } else {
        this.toggleError("email", "", "");
      }
      if (!this.passwordValid) {
        this.toggleError("password", "error", "La password deve avere almeno 6 caratteri");
      } else {
        this.toggleError("password", "", "");
      }
      if (!this.schoolValid) {
        this.toggleError("school", "error", "Seleziona una scuola");
      } else {
        this.toggleError("school", "", "");
      }
    },
    dateUpdate(date) {
      this.student.birth_day = date.birth_day;
      this.student.birth_month = date.birth_month;
      this.student.birth_year = date.birth_year;
    },
    hasActiveErrors() {
      let hasError = false;
      Object.keys(this.errors).forEach(key => {
        if (this.errors[key].state === "error") hasError = true;
      });
      if (!this.student.birth_day || !this.student.birth_month || !this.student.birth_year) hasError = true;
      return hasError;
    },
    saveStudent() {
      this.checkDate = true;
      this.checkValidity();
      this.$nextTick(async () => {
        if (!this.hasActiveErrors()) {
          const childCreatePayload = {
            cons_consumi: this.student.cons_consumi,
            cons_promo: this.student.cons_promo,
            cons_promo3: this.student.cons_promo3,
            email: this.student.email,
            firstname: this.student.firstname,
            lastname: this.student.lastname,
            password: this.student.password,
            role: this.student.role,
            sito_sorgente: this.student.sito_sorgente,
          };
          const childModifyPayload = {
            avatar: this.student.avatar,
            birth_day: this.student.birth_day,
            birth_month: this.student.birth_month,
            birth_year: this.student.birth_year,
            progress: "COMPLETED",
            student_school: this.student.student_school,
          };
          document.querySelector("body").classList.add("wait");
          try {
            const newChild = await User.setChild(this.$root.config, childCreatePayload);
            await User.modifyUserEntities(this.$root.config, newChild.id, childModifyPayload);
            await User.modifyUserEntities(this.$root.config, newChild.parent_id, { progress: "COMPLETED" });
            await this.fetchUser(true);
          } catch (e) {
            Sentry.captureException(e);
          }
          document.querySelector("body").classList.remove("wait");
          this.$emit("modal-close");
        }
      });
    },
    studentSchoolDisabled(grade) {
      return (
        !this.student.student_school ||
        (this.student.student_school !== grade &&
          (!this.$root.config.schoolsTypologies.includes(this.student.student_school) || grade !== this.lastGrade))
      );
    },
    studentSchoolSelected(grade) {
      return (
        this.student.student_school === grade ||
        this.$root.config.schoolsTypologies.includes(this.student.student_school)
      );
    },
    toggleAvatarModal(open) {
      if (open) {
        this.studentModal.scrollTo(0, 0);
        this.studentModal.style.overflowY = "hidden";
      } else {
        this.studentModal.style.overflowY = "auto";
      }
      this.showAvatarsModal = open;
    },
    toggleError(field, state, message) {
      this.errors[field] = { state, message };
    },
    updateUserAvatar(payload) {
      this.student.avatar = payload.avatar;
      this.showAvatarsModal = false;
      this.studentModal.style.overflowY = "auto";
    },
    updateUserSchoolInfo(payload) {
      this.$set(this.student, payload.label, payload.value);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$date-input-width: 120px;
$text-input-width: 300px;

.dea-modal-create-student {
  background-color: $dea-color-white;
  bottom: 0;
  display: none;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 15;

  &--visible {
    display: block;
  }

  &__form-container {
    margin: $space-large + $dea-header-height auto $space-large;
    max-width: $bp-size-medium;
    width: 80%;
  }

  &__title {
    margin-bottom: $space-base;
  }

  &__section-title {
    margin-bottom: $space-m-small;
    width: 100%;
  }

  &__section-subtitle {
    margin-bottom: $space-x-small;
    margin-top: $space-x-small;
  }

  .dea-input {
    width: $text-input-width;
  }

  .input--hidden {
    display: none;
  }

  &__input-block {
    margin: $space-large 0 $space-base;

    &--error {
      align-items: unset;
    }

    &--no-margin {
      margin-top: 0;
    }

    &--inline {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 0;
    }

    .dea-input {
      margin-right: $space-small;

      label {
        display: block;
      }

      &:last-child {
        margin-bottom: $space-small;
      }
    }
  }

  &__email-custom {
    display: flex;
    margin: $space-small 0;

    .dea-links {
      margin-left: $space-xx-large + $space-large;
    }
  }

  &__school-grade {
    margin-bottom: 0;
  }

  &__main-grade-choice,
  &__typology-choice {
    @include media("<=xs") {
      display: block;
    }
    display: flex;
    flex-wrap: wrap;

    .dea-button {
      @include media("<=xs") {
        margin-right: 0;
        width: 100%;
      }
      margin-bottom: $space-small;
      margin-right: $space-small;

      &--disabled,
      &--disabled .dea-button__label {
        border-color: $dea-color-grey-medium;
        color: $dea-color-grey-medium;
      }

      &--selected {
        border-color: $dea-color-black;
      }
    }
  }

  .dea-modal__submit-button {
    margin-top: $space-base;
  }
}

.header--flow--student {
  left: 0;
  position: fixed;
  right: 0;
  z-index: 9;

  .logo-deascuola--desktop {
    width: $dea-logo-size-header;
  }
}
</style>
